var md5 = require("blueimp-md5");
var sha1 = require('js-sha1');
var Dexie = require('dexie')

/* Preassumption The backend will be the localstorage
*/

const ALLOWED_MEDIA_TYPES = ['jpg','jpeg','bmp','gif','tif','png','ico','webp','otf','eot','svg','ttf','woff','woff2']

class Get_Backend  {
  constructor ()  {
    this.db =  new Dexie("Blended");
  }

  delete_data  () {
    var _this = this
    var promise = new Promise(function(resolve, reject) {
          try {
            let tmp  =  _this.db.delete();
            return resolve (tmp)
          } catch (e) {
             reject (e)
          }
    });
    return promise
  }

  delete_data_simple () {
    this.db.delete();
  }

  add_data (name, data) {
     var _this = this
       var promise = new Promise(function(resolve, reject) {
          try {
            _this.db.version(1).stores({ hasan: 'name, data' });
            _this.db.open().then(function(){
              resolve (_this.db.hasan.add({'name' :name, 'data' : data}));
        })
          } catch (e) {
             reject (e)
          }
    });
       return promise

  }

  getData (name) {
    var _this = this
    var promise = new Promise(function(resolve, reject) {
          if (!_this.db.hasOwnProperty('hasan')) {
            console.log("No db found")
            reject ("message")
          }
          try {
            console.log("DB available")
            resolve (_this.db.hasan.where('name').equals(name).toArray())
            /*_this.db.hasan.where('name').equals(name).toArray(data.map(value=>{
              return resolve ((value[name]))
            }))*/
          } catch (e) {
             reject (e)
          }
    });
    return promise
  }
}


class Backend {
  constructor(theme_directory) {
    this.theme_directory =  theme_directory
    this.undoStack = []
    this.redoStack = []

    this.intermediary = Intermediary;
    this.Directory = Directory;
    this.TextFile = TextFile;
    this.JSONFile = JSONFile;
    this.BinaryFile = BinaryFile;
    this.db =  new Get_Backend();
  }

  get_package (directory_path, callback) {
    /*
        This is getting called by the Controller get_package
        It will search for the directory in the localstorage
        if found will return it
        else will make a call to the host
    */
    let project_json    = {};
    let dependency_dict = {};
    var project_object  = [];

    this.db.getData(directory_path).then((data)=>{
        if (data !== undefined && data !== null && data instanceof Array && data.length > 0) {
          // project_object        = JSON.parse (localStorage.getItem (directory_path))
          directory_path        = directory_path.split("/").join("-");
          var intermediary      = new this.Directory(directory_path, null, null, null, data[0].data);
          delete intermediary.data;
          intermediary.location = "/";
          intermediary.name     = "/";
          return callback(intermediary);
        } else {
          return callback(false);
        }
        // console.log(data)
    }, (reason)=>{
        return callback(false);
        console.log(reason)
    })

    /*
     if (directory_path === 'remodeling1'){
       // This thing will get change in return false It is for testing purpose
       const project = require ("./../data/intermediatory.json")
       return project;
     } else {
       return [{"_project.json":{"name":"test","uuid":"2221"}},{"a.json":'{"style.css":"aaaaaaaaaa"}'}]
     }
    */
  }

  get_class (classname) {
      var classes = {   "intermediary" : Intermediary, 
                        "Directory" : Directory, 
                        "JSONFile" : JSONFile, 
                        "TextFile" : TextFile,
                        "BinaryFile" : BinaryFile 
                    };
      return classes[classname]
  }

  save_package (intermediary, package_name, callback){
      // convert intermediary to localStorage object
      var _this = this
      try{
          let filename = package_name;
          /*intermediary.content.map(function(value) {
            if(value.name === "_package.json"){
              filename = JSON.parse(value.content).name;     // retrieve loction from _package.json from project_object
            }
          });
          if(filename === ""){
            filename = package_name;
          }*/
          var location  = filename.split("/").join("-");
          var dict_copy =  Object.assign({}, intermediary);
          var jptf      = this.intermediary_to_local(intermediary.content)
          var obj       = [{[location] : {"type" : "directory", "content" : jptf}}]
          obj = this.rec_path_print(obj, "")                          // for location of each object
          
          this.db.delete_data_simple()
            _this.db.add_data(filename, obj).then(value => {
                  localStorage.setItem("package", value);
                  return  callback (value)  
              }, reason => {
                  return  callback (reason) // Error!
                });

      } catch (e) {
          throw new Error("blendedError: save_package");
      }

  }

  remove_package (){
    this.db.delete_data_simple();
    // localStorage.removeItem(localStorage.getItem("package"));
    localStorage.removeItem(localStorage.getItem("package") + ".hash");
    localStorage.removeItem("package");
  }

  intermediary_to_local (project_object) {
    // => called from save_local of controller
    try{
        for (var index in project_object){
            var item = project_object[index],
                key = item.name,
                value = item.content,
                keys = key.split(".");  //TODO  if abc.cde.html => [abc.cde, html]
            if(keys.length > 1){
                var with_extension = true;
                var extension = key.split(".")[key.split('.').length-1];
            } else {
                var with_extension = false;
            }
            if(value instanceof Array){
                value = this.intermediary_to_local(value);            
                project_object[index] = {[key]: {"type": "directory", "content": value}}
            } else if(with_extension &&  ALLOWED_MEDIA_TYPES.indexOf(extension.toLowerCase()) > -1){              
                project_object[index] = {[key]: {"type": "media", "content": value, "hash": item.hash}}
            } else if(item instanceof this.JSONFile){
                project_object[index] = {[key]: {"type": "file", "content": value, "hash": item.hash}}
            } else if (item instanceof this.TextFile){                
                project_object[index] = {[key]: {"type": "file", "content": value, "hash":  item.hash}}
            }
        }
        return project_object
    } catch(e){
        return null
    }
  }

  rec_path_print (dir, path_str) {
      for(var i=0;i<dir.length;i++) {
        for(var key in dir[i]) {
          if(dir[i][key].type == "file" || dir[i][key].type == "media") {
              dir[i][key].location = "" + path_str + "/" + key;
          } else {
              var temp_path_str = "" + path_str + "/" + key;
              dir[i][key].location = temp_path_str;
              this.rec_path_print(dir[i][key].content, temp_path_str);
          }
        }
      }
      return dir;
  }

  get_all_project () {
    /* return all the project saved in the local storage */
    let projects = {};
    for(var i=0, len=localStorage.length; i<len; i++) {
       var key = localStorage.key(i);
       var value = localStorage[key];
       projects [key] = JSON.parse (value);
     }
    return projects
  }

  get_current_account () {
    return localStorage.getItem("userSlug");
  }

  validate (project) {
    //TODO
  }

  save_css (name , content) {
    localStorage.setItem (name, content)
    return name;
  }

  save_js (name , content) {
    localStorage.setItem (name, content)
    return name;
  }

  save_image (image_name , image_content) {
    localStorage.setItem (image_name ,  image_content);
    return image_name;
  }

  get_image (image_url) {
    return localStorage.getItem(image_url);
  }

  load_image (image_url) {
    return localStorage.getItem(image_url);
  }

  make_active (theme) {
    let active_theme =  localStorage.getItem("active_theme")
    if (active_theme !== theme) {
       localStorage.setItem('active_theme' ,  theme)
    }
    return true
  }

  get_pk_map () {
    if ( localStorage.getItem ('pk_map')) {
      return  JSON.parse(localStorage.getItem ('pk_map'))
    }
    else {
      return false
    }
  }

  set_pk_map (pk_map){
    try {
      localStorage.setItem ('pk_map' , JSON.stringify (pk_map))
      return true
    } catch (e) {
      return false
    }
  }

  get_hash(name) {
    return localStorage.getItem(name) || false;
  }

  set_hash(name, hash) {
    localStorage.setItem(name, hash)
  }

  doUndo () {
    if (this.undoStack.length > 1) {
     let tmp = Object.assign([],this.undoStack)
     let i = this.undoStack.pop()
     this.redoStack.push (i)
     return this.undoStack [this.undoStack.length-1]
    } else {
      return false
    }
  }

  doRedo () {
    if (this.redoStack.length > 0) {
      let tmp = Object.assign([],this.undoStack)
      let k = this.redoStack.pop ()
      this.undoStack.push (k)
      return this.undoStack [this.undoStack.length-1]
    } else {
      return false
    }
  }

  pushLocalChanges (data) {
    this.undoStack.push (data)
    this.redoStack = []
  }

  revert () {
    let tmp = Object.assign([],this.undoStack)
    this.clearStack ()
    this.undoStack.push(tmp[0]);
    return this.undoStack[0];
  }

  clearStack () {
    this.undoStack = []
    this.redoStack = []
  }
}

class Intermediary {
  constructor(location, content = null, name = null, hash = null, data = null){
    this.location = location.split("/")[location.split("/").length-1];
    
    this.data = data;

    if(content !== null){
      this.content = content;
    } else {
      this.content = this.getContent(location);
    }


    if(name){
      this.name = name;
    } else {
      this.name = this.location.split("/")[this.location.split("/").length-1];
    }

    if(hash){
      this.hash = hash;
    } else {
      this.hash = this.getHash(location);
    }
  }

  getContent (location){
    return this;
  }

  getHash (location){
    if (this.hash){
      return this.hash
    } else {
      this.hash = this.generateHash(location)
      return this.hash;
    }
  }

  getContentAtLocation (location) {
    try{
      location = location.split("/");
      if(location[0] === "") location.shift();
      // var data = JSON.parse(localStorage.getItem(location[0].split("-").join("/")));
      var data = this.data;
      return this.get_content_at_location(data, location, 0);
    }catch (e) {
      throw new Error("BlendedError: Backend");
    }
  }

  get_content_at_location(data, path, i) {
    for(var keys in data){
        if (Object.keys(data[keys])[0] == path[i] && i == path.length-1) {
            return data[keys]
            break;
        } else if (Object.keys(data[keys])[0] == path[i]) {
            return this.get_content_at_location(data[keys][Object.keys(data[keys])]["content"], path, ++i);
            break;
        }  
    }
  }

}

class Directory extends Intermediary {

  generateHash (){
    var file_hash_list = [];
    for(var key in this.content){
      file_hash_list.push(this.content[key].name + ":" + this.content[key].hash);
    }
    return md5(file_hash_list.sort().join("::"));
  }

  getContent (location) {
    var content = [];
    var directory_content = this.getContentAtLocation(location);
    directory_content = directory_content[Object.keys(directory_content)[0]].content;
    for (var key in directory_content){
      var value = directory_content[key][Object.keys(directory_content[key])[0]];
      var file_location = value.location;
      var file_name = Object.keys(directory_content[key])[0];
      content.push(this.get_content_at_path(file_location))
    }
    return content;
  }

  get_content_at_path (file_location) {
    var file_extension = file_location.split(".")[file_location.split(".").length-1]; // extension of file
    var value = this.getContentAtLocation(file_location);
    if(value[Object.keys(value)[0]].type === "directory"){
        let directory = new Directory(file_location, null, null, null, this.data);
        delete directory.data;
        return directory;
    } else if(ALLOWED_MEDIA_TYPES.indexOf(file_extension.toLowerCase()) > -1){
        let binary = new BinaryFile(file_location, null, null, null, this.data);
        delete binary.data;
        return binary;
    } else if (file_extension.toLowerCase() === "json"){
        let json = new JSONFile(file_location, null, null, null, this.data);
        delete json.data;
        return json;
    } else {
        let text =  new TextFile(file_location, null, null, null, this.data);
        delete text.data;
        return  text;
    }
  }
}

class TextFile extends Intermediary {
 
  generateHash (location) {
    try{
      return md5(this.content);
    } catch (e){
      return this.get_hash(location);
    }
  }

  getContent (file_location) {
    var file_data = this.getContentAtLocation(file_location);
    file_data = file_data[Object.keys(file_data)[0]].content;
    return file_data;
  }

  get_hash(file_location) {
    var file_data = this.getContentAtLocation(file_location);
    var file_hash = file_data[Object.keys(file_data)[0]].hash;
    return file_hash;
  }

}

class JSONFile extends Intermediary {

  generateHash (location) {
    try{
      return md5(this.content);
    } catch(e){
      return this.get_hash(location);
    }
  }

  getContent (file_location) {
    var file_data = this.getContentAtLocation(file_location);
    file_data = file_data[Object.keys(file_data)[0]].content;
    return file_data;
  }

  get_hash(file_location) {
    var file_data = this.getContentAtLocation(file_location);
    var file_hash = file_data[Object.keys(file_data)[0]].hash;
    return file_hash;
  }

}

class BinaryFile extends Intermediary {
  
  generateHash (location) {
    // return sha1(this.content);
    return this.get_hash(location);
  }

  getContent (file_location) {
    var file_data = this.getContentAtLocation(file_location);
    file_data = file_data[Object.keys(file_data)[0]].content;
    return file_data;
  }

  get_hash(file_location) {
    var file_data = this.getContentAtLocation(file_location);
    var file_hash = file_data[Object.keys(file_data)[0]].hash;
    return file_hash;
  }
}









export {Intermediary, Directory, TextFile, JSONFile, BinaryFile, Backend};


/** WEBPACK FOOTER **
 ** ./~/blended-hostlib-js/Controller/Backend.js
 **/